export default __webpack_public_path__ + "static/media/calculator-frame.8db3dfb5.svg";